import {ErrorMessage, Field} from "formik";
import {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {useRequestContext} from "../../../hooks/useRequestContext";
import {cities, civilStatus, departments, estractos, nivelEstudios, typeVivienda} from "../../../__mocks__/data";
import './applicant-info.scss';
import {renderTypeIdentificationDescription} from "../../../utils/utils";
import _ from "lodash";
import { AdminService, WLOCreditAPIService } from "../../../services";

interface FormPersonalInfoMobileProps {
    errors?: any;
    values?: any;
    setPopup: React.Dispatch<React.SetStateAction<string>>;
}

const maxBirthDate = (() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 18);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
})();

export function FormPersonalInfoMobile(props: FormPersonalInfoMobileProps) {
    const {request} = useRequestContext();
    const {errors, values,setPopup} = props;
    const intl = useIntl();
    const [activelugar, setactive] = useState(false);
    const [entidadesFin, setEntidadesFin] = useState([]);
    const [EstadosCivil, setEstadosCivil] = useState([]);
    const [tipovivi, setTipoVivienda] = useState([]);
    const [fechaexp, setactive2] = useState(false);
    const [NivelEsti, setNivelEstudio] = useState([]);
    const [ciudades, setCiudades] = useState(null) as any;
    const [ciudades2, setCiudades2] = useState(cities as any);
    const [departamentos, setDepartamentos] = useState(cities as any);
    const [allCities, setAllCiudades] = useState(cities as any);
    const [sucursales, setSucursales] = useState([]);
    const [one] = useState(null);

    const hasAniPersona = Boolean(request.searchANI && request.personANI);
    const displayNombres = !request.searchANI
        ? (request.personCygnus?.Pws_Nombres || values.Pws_Nombres || '')
        : hasAniPersona
            ? [request.personANI?.primerNombre, request.personANI?.segundoNombre].filter(Boolean).join(' ')
            : (values.Pws_Nombres || '');
    const displayApellidos = !request.searchANI
        ? ([request.personCygnus?.Pws_Apellidos1, request.personCygnus?.Pws_Apellidos2].filter(Boolean).join(' ') || `${values.Pws_Apellidos1 || ''} ${values.Pws_Apellidos2 || ''}`.trim())
        : hasAniPersona
            ? [request.personANI?.primerApellido, request.personANI?.segundoApellido].filter(Boolean).join(' ')
            : `${values.Pws_Apellidos1 || ''} ${values.Pws_Apellidos2 || ''}`.trim();
    const displayIdentificacion = !request.searchANI
        ? (request.personCygnus?.Pws_Identificacion || values.Pws_Identificacion || '')
        : (request.personANI?.nuip || values.Pws_Identificacion || '');
    const displayTipoIdentificacion = !request.searchANI
        ? renderTypeIdentificationDescription(request.personCygnus?.Pws_Tip_Identificacion || values.Pws_Tip_Identificacion!)
        : renderTypeIdentificationDescription(values.Pws_Tip_Identificacion!);

    useEffect(()=>{
        allData()
        AdminService.getAllCiudades().then((Datos:any)=>{
            setAllCiudades(Datos.payload.data)
            
        if(!request.searchANI){
            if( request.personCygnus?.Pws_Lugar_exp){
                values.Pws_Lugar_exp=request.personCygnus?.Pws_Lugar_exp
                setactive(true)
            }else{
                setactive(true)

            }
        }else{
            if(request.personANI?.municipioExpedicion){
                setactive(true)
            values.Pws_Lugar_exp= _.filter( Datos.payload.data.ListCiudad.Datos_Ciudad, { s_nivel: '3',s_nombre: request.personANI?.municipioExpedicion}).length>0?_.filter( Datos.payload.data.ListCiudad.Datos_Ciudad, {s_nivel: '3', s_nombre: request.personANI?.municipioExpedicion})[0].s_codigo:""
            }else{
                setactive(true)

            }
        }
        if(!request.searchANI){
            if( request.personCygnus?.Pws_Fec_expe){
                values.Pws_Fec_expe = WLOCreditAPIService.fechaCygnusToFormIso(request.personCygnus.Pws_Fec_expe);
                setactive2(false)
            }else{
                setactive2(true)
            }
        }else{
            if(request.personANI?.fechaExpedicion){
                values.Pws_Fec_expe = request.personANI.fechaExpedicion.includes('/')
                    ? `${request.personANI.fechaExpedicion.split('/')[2]}-${request.personANI.fechaExpedicion.split('/')[1]}-${request.personANI.fechaExpedicion.split('/')[0]}`
                    : request.personANI.fechaExpedicion;
                setactive2(false)
            }else if (values.Pws_Fec_expe) {
                setactive2(false)
            }else{
                setactive2(true)
            }
        }
        })
    },[one])
    useEffect(()=>{
       if(allCities){
        
           
        let citiesDepent = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }
        
        
        let citiesDepent2 = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }
        citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '2'});
        setDepartamentos(citiesDepent)
        citiesDepent2.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3'});
        setCiudades2(citiesDepent2);
       }
    },[allCities])
    useEffect(() => {
        if (!allCities?.ListCiudad?.Datos_Ciudad || !values.Pws_Departamento) {
            return;
        }
        setCiudades({
            ListCiudad: {
                Datos_Ciudad: _.filter(allCities.ListCiudad.Datos_Ciudad, {
                    s_nivel: '3',
                    s_ubicacion: values.Pws_Departamento,
                }),
            },
        });
    }, [allCities, values.Pws_Departamento])
    useEffect(() => {
        const fetchSucursal = async () => {
        const sucursal = await AdminService.getSucursal({ s_nombre: values.p_cod_ent });
        try{
            if (sucursal.payload.data.ListSucursales.Datos_Sucursales.length > 0) {
                setSucursales(sucursal.payload.data.ListSucursales.Datos_Sucursales);
            }
                if (values.s_nombre="El Nombre de la entidad no existe o No cuenta con sucursales"){
                    values.s_nombre="1";
                }else{
                    values.s_nombre="1";
                }
        }catch (error){
            console.log(error)
        }
        };
    
        fetchSucursal();
    }, [values.p_cod_ent]);
    const allData= async ()=>{
        const estadosCvil= await AdminService.getEstadosCiviles();
        if(estadosCvil.payload.data.listEstCivil.Datos_EstCivil.length>0){
            setEstadosCivil(estadosCvil.payload.data.listEstCivil.Datos_EstCivil)
        }
        const tipovivienda= await AdminService.gettipovivienda();
        if(tipovivienda.payload.data.tip_viv.datos_tip_vivi.length>0){
            setTipoVivienda(tipovivienda.payload.data.tip_viv.datos_tip_vivi)
        }
        const nivelEstudi= await AdminService.getNivelEstudio();
        if(nivelEstudi.payload.data.listTipoNivEstudio.Datos_TiposNivelEstudio.length>0){
            setNivelEstudio(nivelEstudi.payload.data.listTipoNivEstudio.Datos_TiposNivelEstudio)
        }
        const entidadesFin= await AdminService.getEntidadFin();
        if (entidadesFin.payload.data.LstEntidadBanco.Datos_Entidades.length>0){
            setEntidadesFin(entidadesFin.payload.data.LstEntidadBanco.Datos_Entidades)
        }
    }
    const handleCities = (e: { target: { value: string; }; }) => {
        console.log("allcitiees ", allCities)
        let citiesDepent = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }
        citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3', s_ubicacion: e.target.value });
        
        setCiudades(citiesDepent);
    }

    return (
        <div className="row container-border-app-mobile">
            
            <div className="row">
            <div className="row" >
                <div className="text-left">
                    
                <div className="col" style={{"textAlign":"left"}}>
                     <h3 >Información del solicitante</h3>

                </div>
                </div>
            </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_field_names"})}</div>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>
                            {displayNombres}
                        </div>
                    </div>
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_field_last_names"})}</div>
                        <div
                            className={"label-fields-peps-mobile-ligth display-flex"}>
                            {displayApellidos}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_identification_type"})}</div>
                        <div
                            className={"label-fields-peps-mobile-ligth display-flex"}>
                            {displayTipoIdentificacion}
                        </div>
                    </div>
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_identification"})}</div>
                        <div
                            className={"label-fields-peps-mobile-ligth display-flex"}>
                            {displayIdentificacion}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_expedition_date"})}</div>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>
                        {fechaexp?<>
                        <Field id={"Pws_Fec_expe"}
                                name={"Pws_Fec_expe"}
                                type={"date"}
                                className={`${errors.Pws_Fec_expe ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                                placeholder={'MM/dd/YYYY'}/>
                        </>:<>
                        {!request.searchANI
                            ? WLOCreditAPIService.fechaFormIsoToDisplay(request.personCygnus?.Pws_Fec_expe)
                            : (WLOCreditAPIService.fechaFormIsoToDisplay(request.personANI?.fechaExpedicion || values.Pws_Fec_expe) || '')}
                        </>}
                    </div>
                    </div>
                    <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_expedition_place"})}</div>
                    <div className={"label-fields-peps-mobile-ligth display-flex"}>
                        {activelugar?<>
                            <Field as="select"
                            className={`${errors.Pws_Lugar_exp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            name="Pws_Lugar_exp">
                            <option value="">Lugar Expedicion</option>
                            {ciudades2 && ciudades2.ListCiudad.Datos_Ciudad.map((item:any, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                )
                            })}
                        </Field>
                        </>:<>
                        {_.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3',s_codigo:(!request.searchANI ? request.personCygnus?.Pws_Lugar_exp: values.Pws_Lugar_exp)}).length>0?_.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3',s_codigo:(!request.searchANI ? request.personCygnus?.Pws_Lugar_exp: values.Pws_Lugar_exp)})[0].s_nombre:""}
           
                        </>}
                 </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_date_birth"})}</div>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>
                                <div className="display-flex">
                                    <Field id={"Pws_Fec_nacime"}
                                           name={"Pws_Fec_nacime"}
                                           type="date"
                                           max={maxBirthDate}
                                           className={`${errors.Pws_Fec_nacime ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                                           placeholder={intl.formatMessage({id: "placeholder_date_birth"})}/>
                                           <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Fec_nacime"/>
                        </div>
                                </div>
                           </div>
                    </div>
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_marital_status"})}</div>
                        <Field as="select"
                               className={`${errors.Pws_Estado_Civil ? 'form-know-you-item-input-xs display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               name="Pws_Estado_Civil"
                        >
                            <option value="">{intl.formatMessage({id: "placeholder_marital_status"})}</option>
                            {EstadosCivil && EstadosCivil.map((item:any, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                                )
                            })}
                        </Field>
                        <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Estado_Civil"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "residence_address"})}</div>
                        <Field id={"Pws_Direccion_res"}
                            name={"Pws_Direccion_res"}
                            className={`${errors.Pws_Direccion_res ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                            placeholder={intl.formatMessage({id: "enter"})}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "department"})}</div>

                        <Field as="select"
                               className={`${errors.Pws_Departamento ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                               name="Pws_Departamento"
                               onClick={handleCities}
                        >
                            <option value="">{intl.formatMessage({id: "form_financial_city_foreign_currency"})}</option>
                            {departamentos && departamentos.ListCiudad.Datos_Ciudad.map((item:any, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                )
                            })}
                        </Field>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "form_financial_city_foreign_currency"})}</div>

                        <Field as="select"
                               className={`${errors.Pws_Ciudad_res ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                               name="Pws_Ciudad_res"
                        >
                            <option value="">{intl.formatMessage({id: "form_financial_city_foreign_currency"})}</option>
                            {ciudades && ciudades.ListCiudad.Datos_Ciudad.map((item: any, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                )
                            })}
                        </Field>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_mobile_phone_1"})}</div>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>{values.Pws_Telefono1}</div>
                    </div>
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_mobile_phone_2"})}</div>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>{values.Pws_Telefono2}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_mail"})}</div>
                        <div className={"label-fields-peps-mobile-ligth display-flex"}>{values.Pws_Correo}</div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "gender"})}</div>
                        <div className="display-flex">
                            <Field as="select"
                                   className={`${errors.Pws_Genero ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                                   name="Pws_Genero">
                                <option value="">{intl.formatMessage({id: "placeholder_dropdown"})}</option>
                                <option value={'F'}>{'Femenino'}</option>
                                <option value={'M'}>{'Masculino'}</option>
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_social_stratum"})}</div>
                        <div className="display-flex">
                            <Field as="select"
                                   className={`${errors.Pws_Estrato_per ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                                   name="Pws_Estrato_per">
                                <option value="">{intl.formatMessage({id: "placeholder_dropdown"})}</option>
                                {estractos && estractos.WS_ESTRACTOS_SOCResult.estratos_soc.Datos_estratos_soc.map((item, key: number) => {
                                    return (
                                        <option key={key} value={item.i_codigo}>{item.c_descripcion}</option>
                                    )
                                })}
                            </Field>
                        </div>

                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_number_of_people_in_charge"})}</div>
                        <div className="display-flex">
                            <Field as="select"
                                className={`${errors.Pws_Per_cargo ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                                name="Pws_Per_cargo">
                                <option value="">{intl.formatMessage({id: "placeholder_dropdown"})}</option>
                                <option value={'0'}>{'0'}</option>
                                <option value={'1'}>{'1'}</option>
                                <option value={'2'}>{'2'}</option>
                                <option value={'3'}>{'3'}</option>
                                <option value={'4'}>{'4'}</option>
                                <option value={'5'}>{'5'}</option>
                                <option value={'6'}>{'6'}</option>
                                <option value={'7'}>{'7'}</option>
                                <option value={'8'}>{'8'}</option>
                                <option value={'9'}>{'9'}</option>
                                <option value={'10'}>{'10'}</option>
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_type_of_housing"})}</div>
                        <div className="display-flex">
                            <Field as="select"
                                    className={`${errors.Pws_Tip_vivienda ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                                   name="Pws_Tip_vivienda">
                                <option value="">{intl.formatMessage({id: "placeholder_dropdown"})}</option>
                                {tipovivi && tipovivi.map((item:any, key: number) => {
                                    return (
                                        <option key={key} value={item.i_codigo}>{item.c_descripcion}</option>
                                    )
                                })}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div
                            className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({id: "placeholder_educational_level"})}</div>
                        <div className="display-flex">
                            <Field as="select"
                                  className={`${errors.Pws_Niv_estudio ? 'form-know-you-item-input-mobile display-flex input-error' : 'form-know-you-item-input-mobile display-flex'}`}
                                   name="Pws_Niv_estudio">
                                <option value="">{intl.formatMessage({id: "placeholder_dropdown"})}</option>
                                {NivelEsti && NivelEsti.map((item:any, key: number) => {
                                    return (
                                        <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                                    )
                                })}
                            </Field>
                        </div>

                    </div>
                </div>
                {/* Tipo de cuenta, Número de cuenta y Banco ya no se solicitan */}
            </div>
        </div>
    )
}